import ArticleHighlightSection from "./ArticleHighlightSection";
import ArticleLatestSection from "./ArticleLatestSection";

const Dashboard = () => {
  return (
    <div>
      <div className="mx-auto w-11/12 laptop:max-w-full desktop:max-w-7xl ">
        <div className="laptop:grid laptop:grid-cols-3 my-12">
          <div className="flex flex-col col-span-2 p-4">
            <ArticleLatestSection />
            <br />
          </div>

          <div className="flex flex-col gap-8 p-4">
            <div className="basis-1/1">
              <ArticleHighlightSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
